import React, {Component} from 'react';
import PropTypes from 'prop-types';

import AppBar from '@material-ui/core/AppBar';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import Icon from '@material-ui/core/Icon';
import Avatar from '@material-ui/core/Avatar';
import MenuItem from '@material-ui/core/MenuItem';
import Menu from '@material-ui/core/Menu';
import Tooltip from '@material-ui/core/Tooltip';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';

import { translate } from 'react-i18next';

import Sidebar from './Sidebar';

import './styles/topbar.css';


class Topbar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      profileMenuAnchorEl: null,
      showDrawer: false,
    }
  }

  componentWillMount() {
    const { t } = this.props;
    this.texts = t('layout.navigation.topbar', {returnObjects: true});
  }

  handleMenu = event => {
    this.setState({ profileMenuAnchorEl: event.currentTarget });
  };

  handleProfileMenuClose = event => {
    let action = event.currentTarget.id;

    switch (action) {
      case 'logout':
        this.props.logout(this.context.router.history);
        break;
      default:
    }

    this.setState({ profileMenuAnchorEl: null });
  };

  render() {
    const isMenuOpen = Boolean(this.state.profileMenuAnchorEl);
    const isDrawerOpen = this.state.showDrawer;

    return (
      <AppBar position="fixed">
        <div className="navigation-topbar-container">
          <div className="navigation-topbar-main-container">
            <IconButton
              color="inherit"
              onClick={() => this.setState({showDrawer: true})}
            >
              <Icon> menu </Icon>
            </IconButton>

            <Sidebar
              isOpen={isDrawerOpen}
              onClose={() => this.setState({showDrawer: false})}
              onNavigation={link => this.context.router.history.push(link)}
            />


            <div className="navigation-topbar-main-title-container">
              <Typography variant="title" color="inherit">
                {this.props.title}
              </Typography>
            </div>
          </div>

            <div className="navigation-topbar-options-container">
              <IconButton
                color="inherit"
                aria-owns={isMenuOpen ? 'menu-appbar' : null}
                aria-haspopup="true"
                onClick={this.handleMenu}
              >
              <Tooltip title={
                `${this.props.session.user.firstName} ${this.props.session.user.lastName}`
              } placement="left">
                <Avatar src={this.props.session.user.photo}/>
              </Tooltip>
              </IconButton>
              <Menu
                id="menu-appbar"
                anchorEl={this.state.profileMenuAnchorEl}
                anchorOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                open={isMenuOpen}
                onClose={this.handleProfileMenuClose}
              >
                <MenuItem id='logout' onClick={this.handleProfileMenuClose}>
                  <ListItemIcon>
                    <Icon> exit_to_app </Icon>
                  </ListItemIcon>
                  <ListItemText inset primary={this.texts.profile.menu.logOut} />
                </MenuItem>
              </Menu>
            </div>
        </div>
      </AppBar>
    );
  }
}

Topbar.contextTypes = {
   router: PropTypes.object
}

export default translate('translations')(Topbar);



// WEBPACK FOOTER //
// ./src/components/modules/navigation/Topbar.js